import { MapProperty } from 'cadenza/map/map-property';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

export class HighlightHandler {

  constructor (map) {
    this._map = map;
  }

  highlightFeatures (features) {
    this.resetHighlighting();
    if (features && features.length) {
      this._getHighlightVectorSource().addFeatures(features);
    }
  }

  resetHighlighting () {
    this._getHighlightVectorSource().refresh();
  }

  _getHighlightVectorSource () {
    if (!this._highlightVectorSource) {
      this._highlightVectorSource = createHighlightVectorSource(this._map);
    }
    return this._highlightVectorSource;
  }

}

function createHighlightVectorSource (map) {
  const source = new VectorSource();
  const styles = map.get(MapProperty.HIGHLIGHT_STYLES);
  // eslint-disable-next-line no-new
  new VectorLayer({
    id: 'highlightlayer',
    source,
    map,
    style: feature => styles[feature.getGeometry().getType()]
  });
  return source;
}
